import { fork, take, call, put } from 'redux-saga/effects'

import {
    createFoldrResponse,
    getOrderHistoryResponse,
    createFileResponse,
    deleteFolderReqResponse,
    deleteFileResponse,
    detailFolderResponse,
    toolboxUpdateTimeResponse,
    getSubscriptionResponse,
    cancelSubscriptionReqResponse,
    getOrderDetailResponse
} from './actions'
import types from './types'
import { getAPI, postAPIWithoutModule } from '../../api/generic'

export function* doGetOrderHistory() {
    while (true) {
        const { payload } = yield take(types.ORDER_HISTORY)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(getOrderHistoryResponse(response))
    }
}

export function* doCreateFolder() {
    while (true) {
        const { payload } = yield take(types.CREATE_FOLDER)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(createFoldrResponse(response))
    }
}
// create file -toolbox
export function* doCreateFile() {
    while (true) {
        const { payload } = yield take(types.CREATE_FILE)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(createFileResponse(response))
    }
}
// delete folder -toolbox
export function* doDeleteFolder() {
    while (true) {
        const { payload } = yield take(types.DELETE_FOLDER)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(deleteFolderReqResponse(response))
    }
}
// delete file -toolbox
export function* doDeleteFile() {
    while (true) {
        const { payload } = yield take(types.DELETE_FILE)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(deleteFileResponse(response))
    }
}
// details -toolbox
export function* doGetFolderDetails() {
    while (true) {
        const { payload } = yield take(types.FOLDER_DETAIL)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(detailFolderResponse(response))
    }
}

export function* doGetSearchFolderDetails() {
    while (true) {
        const { payload } = yield take(types.TOOLBOX_SEARCH)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(detailFolderResponse(response))
    }
}

export function* doToolboxUpdateTime() {
    while (true) {
        const { payload } = yield take(types.TOOLBOX_UPDATE_TIME)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(toolboxUpdateTimeResponse(response))
    }
}

export function* doGetSubscription() {
    while (true) {
        const { payload } = yield take(types.SUBSCRIPTION_DATA)
        console.log('SUBSCRIPTION', payload);
        const response = yield call(postAPIWithoutModule, payload)
        yield put(getSubscriptionResponse(response))
    }
}

export function* doCancelSubscription() {
    while (true) {
        const { payload } = yield take(types.CANCEL_SUBSCRIPTION)
        console.log('SUBSCRIPTION', payload);
        const response = yield call(postAPIWithoutModule, payload)
        yield put(cancelSubscriptionReqResponse(response))
    }
}

export function* doGetOrderDetail() {
    while (true) {
        const { payload } = yield take(types.ORDER_DETAIL)
        const response = yield call(postAPIWithoutModule, payload)
        yield put(getOrderDetailResponse(response))
    }
}


function* orders() {
    yield fork(doGetOrderHistory)
    yield fork(doCreateFolder)
    yield fork(doCreateFile)
    yield fork(doDeleteFolder)
    yield fork(doDeleteFile)
    yield fork(doGetFolderDetails)
    yield fork(doGetSearchFolderDetails)
    yield fork(doToolboxUpdateTime)
    yield fork(doGetSubscription)
    yield fork(doCancelSubscription)
    yield fork(doGetOrderDetail)
}
export default orders